import type { ApiResponse, InstructionVersionPayload } from '@/store/types'
import { post } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { UUID } from '@/backend/schema/uuid'
import {
  decodeInstructionVersion,
  type InstructionVersion,
} from '@/backend/schema/instructionVersion'

/**
 * Creates AI assisted review instruction version on backend
 */
export const createInstructionVersion = async (params: {
  team_slug: string
  id: UUID
  content: string
  multi_modal: boolean
  active: boolean
}): Promise<ApiResponse<InstructionVersion> | ParsedError> => {
  const { team_slug, id, ...rest } = params
  const path = `v2/teams/${team_slug}/ai_review/instructions/${id}/versions`

  try {
    const response = await post<InstructionVersionPayload>(path, rest)

    return {
      data: decodeInstructionVersion(response.data),
    }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error, errorMessages.INSTRUCTION_VERSION_CREATE)
  }
}
